module.exports = __webpack_public_path__ + "static/media/circleGrn.204d49d7.svg";